// This module provides API call methods for Sephora Commerce
// Beauty Insider APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Beauty+Insider+APIs

let getBiPoints = require('./getBiPoints');
let getBiDigitalCardNumber = require('./getBiDigitalCardNumber');
let getBiAccountHistory = require('./getBiAccountHistory');
let createBiAccount = require('./createBiAccount');
let updateBiAccount = require('./updateBiAccount');
let getPurchaseHistory = require('./getPurchaseHistory');
let addBiRewardsToCart = require('./addBiRewardsToCart');
let removeBiRewardFromBasket = require('./removeBiRewardFromBasket');
let getBiRewards = require('./getBiRewards');
let {
    getBiRewardsGroupForCheckout,
    getBiRewardsGroupForProfile,
    getBiRewardsGroupForSnapshot,
    getBiRewardsGroupForOrderConf
} = require('./getBiRewardsGroup');
let getClientSummary = require('./getClientSummary');

module.exports = {
    getBiPoints,
    getBiDigitalCardNumber,
    getBiAccountHistory,
    createBiAccount,
    updateBiAccount,
    addBiRewardsToCart,
    removeBiRewardFromBasket,
    getPurchaseHistory,
    getBiRewardsGroupForCheckout,
    getBiRewardsGroupForProfile,
    getBiRewardsGroupForSnapshot,
    getBiRewardsGroupForOrderConf,
    getBiRewards,
    getClientSummary
};
